// reducers/AccessKeyReducer.js
import {
    ACCESS_KEYS_LOADING,
    ACCESS_KEYS_LOADED,
    ACCESS_KEYS_FAILED,
    ACCESS_KEYS_SAVED,
  } from "../actions/AccessKeyActions";
  
  const initialState = {
    loading: false,
    data: {},
    error: null,
  };
  
  const AccessKeyReducer = (state = initialState, action) => {
    switch (action.type) {
      case ACCESS_KEYS_LOADING:
        return { ...state, loading: true, error: null };
  
      case ACCESS_KEYS_LOADED:
        return { ...state, loading: false, data: action.payload };
  
      case ACCESS_KEYS_SAVED:
        return { ...state, loading: false, data: action.payload };
  
      case ACCESS_KEYS_FAILED:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default AccessKeyReducer;
  